import axios from "axios";

export async function subtract(targetObj: string, toolObj: string): Promise<string> {
    const response = await axios.post<string>('/api/solids/subtract', { target: targetObj, tool: toolObj });

    return response.data;
}

